<div class="pie-card">
  <div class="header">
    <h2>
      {{ config.title }}
    </h2>
    @if (config.subtitle) {
    <h3>
      {{ config.subtitle }}
    </h3>
    }
  </div>

  <section class="pie-card__content">
    <div class="pie-card__chart">
      <canvas
        baseChart
        [type]="chartType"
        [data]="chartData"
        [options]="chartOptions"
        [plugins]="chartPlugins"
      ></canvas>
    </div>
  </section>
</div>
